export const whiteLocaleList = ['us'];
